import BaseNodeResolver from '@/Modules/Quote/Components/QuoteForm/UiRules/BaseNodeResolver.js'
import UiRuleAction from '@/Modules/Quote/Components/QuoteForm/UiRules/Actions/UiRuleAction.js'

export default class ToggleVisibility extends UiRuleAction {
  constructor(baseNode) {
    super(baseNode, new BaseNodeResolver(baseNode))
  }

  /**
   *
   * @param {object} rule
   * @returns {object} baseNode
   */
  execute(rule) {
    const value = this.resolver.getValueByRuleOrSource(rule)

    this.resolver.setVisibility(rule.target, !!value)

    return this.baseNode
  }
}
